var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("status-badge status-badge__" + _vm.status)})}
var staticRenderFns = []

export { render, staticRenderFns }